/* eslint-disable */
const normalizeIdentifier = require('micromark/dist/util/normalize-identifier');

exports.canContainEols = ['shortcode'];
exports.enter = {
  shortcodeCallString: enterShortcodeCallString
};
exports.exit = {
  shortcodeCallString: exitShortcodeCallString
};

function enterShortcodeCallString(token) {
  this.buffer();
}

function exitShortcodeCallString(token) {
  const [identifier, ...initialAttrPairs] = this.resume().split(' ').filter(key => key !== '');
  const attrPairs = initialAttrPairs.join(' ').match(/(\w+)=(?:"([^"]*)"|(\S*))/g);
  const attr = {};
  attrPairs === null || attrPairs === void 0 ? void 0 : attrPairs.forEach(pair => {
    const [key, value] = pair.split('=');
    attr[key] = value.replace(/\"/g, '');
  });
  this.enter({
    type: 'shortcode',
    identifier: identifier,
    label: '',
    children: [],
    attributes: attr
  }, token);
  this.exit(token);
}